import React, { useEffect, useState, createElement } from 'react';
import { Hero } from './components/Hero';
import { SpecsBar } from './components/SpecsBar';
import { Features } from './components/Features';
import { Description } from './components/Description';
import { PropertyMap } from './components/PropertyMap';
import { CtaFooter } from './components/CtaFooter';
export function App() {
  const [active, setActive] = useState('residence');
  // Google Analytics (gtag.js) — G-N48MJ5BXHP
  useEffect(() => {
    const GA_ID = 'G-N48MJ5BXHP';
    if (document.querySelector(`script[data-ga-id="${GA_ID}"]`)) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    script.setAttribute('data-ga-id', GA_ID);
    document.head.appendChild(script);
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    function gtag(...args: any[]) {
      w.dataLayer.push(args);
    }
    w.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_ID);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['residence', 'features', 'story', 'location', 'inspect'];
      let current = 'residence';
      for (const section of sections) {
        const el = document.getElementById(section);
        if (el && window.scrollY >= el.offsetTop - 300) {
          current = section;
        }
      }
      setActive(current);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    id: 'residence',
    num: '00',
    label: 'RESIDENCE'
  }, {
    id: 'features',
    num: '01',
    label: 'FEATURES'
  }, {
    id: 'story',
    num: '02',
    label: 'STORY'
  }, {
    id: 'location',
    num: '03',
    label: 'LOCATION'
  }, {
    id: 'inspect',
    num: '04',
    label: 'INSPECT'
  }];
  return <div className="min-h-screen bg-cream w-full flex overflow-x-hidden font-sans text-charcoal selection:bg-terracotta selection:text-cream" data-id="element-0">
      {/* Sidebar - Fixed Index */}
      <aside className="hidden md:flex w-64 fixed inset-y-0 left-0 border-r border-charcoal/20 flex-col justify-between p-8 z-50 bg-cream" data-id="element-1">
        <div data-id="element-2">
          <div className="w-3 h-3 bg-terracotta mb-16" data-id="element-3" />
          <nav className="flex flex-col gap-6" data-id="element-4">
            {navItems.map(item => <a key={item.id} href={`#${item.id}`} className={`text-[10px] tracking-[0.2em] flex items-center gap-4 transition-colors duration-300 ${active === item.id ? 'text-terracotta font-semibold' : 'text-ink-soft hover:text-charcoal'}`} data-id="element-5">
                <span data-id="element-6">{item.num}</span>
                <span data-id="element-7">{item.label}</span>
              </a>)}
          </nav>
        </div>
        <div className="text-[9px] tracking-[0.2em] text-ink-soft uppercase leading-relaxed" data-id="element-8">
          1 Lanoma Court
          <br data-id="element-9" />
          Wheelers Hill
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 md:ml-64 w-full" data-id="element-10">
        <Hero data-id="element-11" />
        <SpecsBar data-id="element-12" />
        <Features data-id="element-13" />
        <Description data-id="element-14" />
        <PropertyMap data-id="element-15" />
        <CtaFooter data-id="element-16" />
      </main>
    </div>;
}